import createIcon from '../../createIcon';

/**
 * @component @name Layers
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTkgMTkuMDA0OEw0LjYyIDEzLjI3NDhMMyAxNC41MzQ4TDEyIDIxLjUzNDhMMjEgMTQuNTM0OEwxOS4zNyAxMy4yNjQ4TDExLjk5IDE5LjAwNDhaTTEyIDE2LjQ2NDhMMTkuMzYgMTAuNzM0OEwyMSA5LjQ2NDg0TDEyIDIuNDY0ODRMMyA5LjQ2NDg0TDQuNjMgMTAuNzM0OEwxMiAxNi40NjQ4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Layers = createIcon('Layers', [
  [
    'path',
    {
      d: 'M11.99 19.0048L4.62 13.2748L3 14.5348L12 21.5348L21 14.5348L19.37 13.2648L11.99 19.0048ZM12 16.4648L19.36 10.7348L21 9.46484L12 2.46484L3 9.46484L4.63 10.7348L12 16.4648Z',
      key: 'zj9rz8',
    },
  ],
]);

export default Layers;
